import React, { useEffect } from 'react';

import { routeInviteRequest } from '../../lib/inviteCodeRouter';
import { detectPlatform } from '../DeepLinkUtils';

export default function StudentInviteRedirect() {
  const params = new URLSearchParams(window.location.search);
  const segments = window.location.pathname.split('/').filter(Boolean);
  const pathCompanyId = segments[segments.length - 1];
  const companyId = pathCompanyId || params.get('companyId') || undefined;

  // Check routing and redirect immediately
  useEffect(() => {
    const handleRouting = async () => {
      if (!companyId) {
        window.location.href = '/';
        return;
      }

      const platform = detectPlatform();
      const searchParams = new URLSearchParams();
      searchParams.set('companyId', companyId);
      
      const routing = await routeInviteRequest(searchParams, platform);

      if (routing.shouldRedirectToMobile && routing.mobileDeepLink) {
        // Redirect to mobile app (only if explicitly from mobile app)
        window.location.href = routing.mobileDeepLink;
        return;
      }

      if (routing.shouldHandleWebSide && routing.webRoute) {
        // Handle web-side - redirect immediately
        window.location.replace(routing.webRoute);
        return;
      }

      // Fallback: redirect to signup page
      window.location.replace('/signup');
    };

    handleRouting();
  }, [companyId]);

  // Show loading state while routing
  return (
    <div className="min-h-screen bg-[#111010] flex items-center justify-center">
      <div className="text-white">Loading...</div>
    </div>
  );
}

